export default __webpack_public_path__ + "static/media/search-icon-blue.64cd6640.svg";